export const baseUrl = 'https://dev.wix.com';
